import { render, staticRenderFns } from "./SupportBot.vue?vue&type=template&id=46f37669&scoped=true&"
import script from "./SupportBot.vue?vue&type=script&lang=js&"
export * from "./SupportBot.vue?vue&type=script&lang=js&"
import style0 from "./SupportBot.vue?vue&type=style&index=0&id=46f37669&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f37669",
  null
  
)

export default component.exports